import { render, staticRenderFns } from "./changeLanguagePopup.vue?vue&type=template&id=d80842ec&scoped=true&"
import script from "./changeLanguagePopup.vue?vue&type=script&lang=js&"
export * from "./changeLanguagePopup.vue?vue&type=script&lang=js&"
import style0 from "./changeLanguagePopup.vue?vue&type=style&index=0&id=d80842ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80842ec",
  null
  
)

export default component.exports